<template>
  <div id="contenedor-listado-licitacion-eventos-mobile">
    <template v-for="(evento, index) in licitacionEventos">
      <v-card
      :key="index"
      class="mb-3"
      dark
      :color="getColorEvento(evento)">
        <v-card-title>
          {{evento.eventoTexto}}
        </v-card-title>
        <v-card-text>
          <v-row>
            <h3>Fecha: {{ new Date(evento.fechaHora).toLocaleDateString()}}</h3>
          </v-row>
          <v-row>
            <h3>Hora: {{ horaFormatoHrs(evento.fechaHora)}}</h3>
          </v-row>
          <v-spacer></v-spacer>
          <v-row>
            <h3>{{evento.lugar}}</h3>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          v-if="mixValidaScopesActions(2)"
          @click="editarEventoLicitacion(evento)"
          icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
          v-if="mixValidaScopesActions(3)"
          @click="eliminarEventoLicitacion(evento)"
          icon>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoLicitacionEventosMobile',
  props: {
    licitacionEventos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    horaFormatoHrs(fechaHora) {
      const fecha = new Date(fechaHora);
      const horas = fecha.getHours().toString().length === 1 ? `0${fecha.getHours()}` : fecha.getHours();
      const minutos = fecha.getMinutes().toString().length === 1 ? `0${fecha.getMinutes()}` : fecha.getMinutes();
      return `${horas}:${minutos} Hrs.`;
    },
    getColorEvento(evento) {
      if (evento.evento === 1) return '#1E88E5';
      if (evento.evento === 2) return '#673AB7';
      if (evento.evento === 3) return '#43BC82';
      return '#FA8B00';
    },
    editarEventoLicitacion(eventoLicitacion) {
      eventBus.$emit('editar-evento-licitacion', eventoLicitacion);
    },
    eliminarEventoLicitacion(eventoLicitacion) {
      eventBus.$emit('eliminar-evento-licitacion', eventoLicitacion);
    },
  },
};
</script>

<style lang="scss">
</style>
